import PubSub from "pubsub-js";

import { SEARCH_PRODUCTS } from "../../constants";

const Search = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const onSearch = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formProps = Object.fromEntries(formData);

    if (window.location.pathname.indexOf("/search/") > -1) {
      // we don't want reload all page; just send event to SearchResults render component
      // to make a new ajax call
      PubSub.publish(SEARCH_PRODUCTS, formProps.search);
      // change url without reload
      const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?q=${formProps.search}`;
      window.history.pushState({ path: newUrl }, "", newUrl);
    } else {
      // go to search results page
      var url = $("#SEARCH_URL").val();
      window.location.assign(`${url}?q=${formProps.search}`);
    }
  };

  return (
    <form className="d-flex search-form" onSubmit={onSearch}>
      <input
        className="search-input form-control"
        type="search"
        name="search"
        placeholder="Søg"
        aria-label="Søg"
        defaultValue={urlSearchParams.get("q") || ""}
      />
      <button className="btn btn-outline-success" type="submit">
        <svg className="icon icon--search " width="30" height="25">
          <use
            xlinkHref={`${$(
              "#STATIC_ASSETS_URL"
            ).val()}/images/sprites/symbol/sprite.svg#search`}
          ></use>
        </svg>
      </button>
    </form>
  );
};

export default Search;
